export const isRecordInBlockedList = (record, blockedRecords) => {
  if (!record || !blockedRecords || !Array.isArray(blockedRecords) || blockedRecords.length === 0) {
    return false;
  }
  const candidateCodes = [
    record.internalCode,
    record.code,
    record.Code,
    record.CODE,
  ].filter(c => c !== undefined && c !== null).map(String);

  return blockedRecords.some(blockedCode => candidateCodes.includes(String(blockedCode)));
};

export const getRecordProtectedFields = (record, protectedFieldsMap) => {
  if (!record || !protectedFieldsMap || typeof protectedFieldsMap !== 'object') {
    return [];
  }
  const candidateCodes = [
    record.internalCode,
    record.code,
    record.Code,
    record.CODE,
  ].filter(c => c !== undefined && c !== null).map(String);

  for (const code of candidateCodes) {
    if (Array.isArray(protectedFieldsMap[code])) {
      return protectedFieldsMap[code];
    }
  }
  return [];
};

export const isFieldInProtectedList = (field, protectedFieldsList) => {
  if (!field || !protectedFieldsList || !Array.isArray(protectedFieldsList) || protectedFieldsList.length === 0) {
    return false;
  }
  const fieldIdentifiers = [
    field.code,
    field.name,
    field.field,
  ].filter(Boolean).map(val => String(val).toLowerCase());

  return protectedFieldsList.some(item =>
    fieldIdentifiers.includes(String(item).toLowerCase())
  );
};
